(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionStateHistoryDialogController', HandbookVersionStateHistoryDialogController);

    HandbookVersionStateHistoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HandbookVersionStateHistory', 'HandbookVersion', 'CustomUser'];

    function HandbookVersionStateHistoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HandbookVersionStateHistory, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbookVersionStateHistory = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.handbookversions = HandbookVersion.query();
        vm.customusers = CustomUser.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookVersionStateHistory.id !== null) {
                HandbookVersionStateHistory.update(vm.handbookVersionStateHistory, onSaveSuccess, onSaveError);
            } else {
                HandbookVersionStateHistory.save(vm.handbookVersionStateHistory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookVersionStateHistoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.stateSetTimestamp = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
